module.exports = __webpack_public_path__ + "static/media/helengeli-27.f37eea33.jpg";